<template>
  <BriefStep :title="title">
    <template v-slot:content>
      <div class="brief-form">
        <div
          class="form__input-wrapper"
          :class="{ error: $v.form.fullName.$anyError }"
        >
          <label for="full-name" class="form__label">imię i nazwisko *</label>
          <input
            class="form-input"
            id="full-name"
            type="text"
            name="full-name"
            v-model.trim="form.fullName"
            @input="event => delayTouchCounterComposition($v.form, 'fullName', event.target.value)"
          />
          <span class="form__error-message">
            <template v-if="!$v.form.fullName.minLength">
              {{ validationMessage.minLength }}</template
            >
            <template v-if="!$v.form.fullName.required">
              {{ validationMessage.required }}</template
            >
          </span>
        </div>
        <div
          class="form__input-wrapper"
          :class="{ error: $v.form.companyName.$anyError }"
        >
          <label for="company-name" class="form__label">nazwa firmy *</label>
          <input
            class="form-input"
            id="company-name"
            type="text"
            name="company-name"
            v-model.trim="form.companyName"
            @input="event => delayTouchCounterComposition($v.form, 'companyName', event.target.value)"
          />
          <span class="form__error-message">
            <template v-if="!$v.form.companyName.minLength">
              {{ validationMessage.minLength }}</template
            >
            <template v-if="!$v.form.companyName.required">
              {{ validationMessage.required }}</template
            >
          </span>
        </div>
        <div
          class="form__input-wrapper"
          :class="{ error: $v.form.email.$anyError }"
        >
          <label for="e-mail" class="form__label">e-mail *</label>
          <input
            class="form-input"
            id="e-mail"
            type="email"
            name="e-mail"
            v-model.trim="form.email"
            @input="event => delayTouchCounterComposition($v.form, 'email', event.target.value)"
          />
          <span class="form__error-message">
            <template v-if="!$v.form.email.email">{{
              validationMessage.email
            }}</template>
          </span>
        </div>
        <div
          class="form__input-wrapper"
          :class="{ error: $v.form.industry.$anyError }"
        >
          <label for="industry" class="form__label">
            branża / obszar działania *
          </label>
          <input
            class="form-input"
            id="industry"
            type="text"
            name="industry"
            v-model.trim="form.industry"
            @input="event => delayTouchCounterComposition($v.form, 'industry', event.target.value)"
          />
          <span class="form__error-message">
            <template v-if="!$v.form.industry.minLength">
              {{ validationMessage.minLength }}</template
            >
            <template v-if="!$v.form.industry.required">
              {{ validationMessage.required }}</template
            >
          </span>
        </div>
        <div
          class="form__input-wrapper"
          :class="{ error: $v.form.services.$anyError }"
        >
          <label for="services" class="form__label"
            >oferowane usługi / produkty *</label
          >
          <input
            class="form-input"
            id="services"
            type="text"
            name="services"
            v-model.trim="form.services"
            @input="event => delayTouchCounterComposition($v.form, 'services', event.target.value)"
          />
          <span class="form__error-message">
            <template v-if="!$v.form.services.minLength">
              {{ validationMessage.minLength }}</template
            >
            <template v-if="!$v.form.services.required">
              {{ validationMessage.required }}</template
            >
          </span>
        </div>
        <div
          class="form__input-wrapper"
          :class="{ error: $v.form.clients.$anyError }"
        >
          <label for="clients" class="form__label">kim są Twoi klienci?</label>
          <input
            class="form-input"
            id="clients"
            type="text"
            name="clients"
            v-model.trim="form.clients"
            @input="event => delayTouchCounterComposition($v.form, 'clients', event.target.value)"
          />
          <span class="form__error-message">
            <template v-if="!$v.form.clients.minLength">
              {{ validationMessage.minLength }}</template
            >
            <template v-if="!$v.form.clients.required">
              {{ validationMessage.required }}</template
            >
          </span>
        </div>
        <div
          class="form__input-wrapper"
          :class="{ error: $v.form.competition.$anyError }"
        >
          <label for="competition" class="form__label"
            >konkurencja (wskaż firmy z tej samej branży)
          </label>
          <input
            class="form-input"
            id="competition"
            type="text"
            name="competition"
            v-model.trim="form.competition"
            @input="event => delayTouchCounterComposition($v.form, 'competition', event.target.value)"
          />
          <span class="form__error-message">
            <template v-if="!$v.form.competition.minLength">
              {{ validationMessage.minLength }}</template
            >
            <template v-if="!$v.form.competition.required">
              {{ validationMessage.required }}</template
            >
          </span>
        </div>
      </div>
    </template>
  </BriefStep>
</template>
<script>
import { email, minLength, required } from 'vuelidate/lib/validators';
import stepValidation from '../../mixins/stepValidation';
import BriefStep from '../global/BriefStep.vue';

export default {
  name: 'LetsGetToKnow',
  components: { BriefStep },
  mixins: [stepValidation],
  data: () => ({
    title: 'Pierwsze koty za płoty! Poznajmy się bliżej.',
    form: {
      fullName: '',
      companyName: '',
      email: '',
      industry: '',
      services: '',
      clients: '',
      competition: '',
    },
  }),
  validations: {
    form: {
      fullName: {
        required,
        minLength: minLength(3),
      },
      companyName: {
        required,
        minLength: minLength(3),
      },
      email: {
        required,
        email,
      },
      industry: {
        required,
        minLength: minLength(2),
      },
      services: {
        required,
        minLength: minLength(3),
      },
      clients: {
        minLength: minLength(2),
      },
      competition: {
        minLength: minLength(2),
      },
    },
  },
};
</script>
